import { EntityIndex, EntityID, World } from "@latticexyz/recs";
import { ActionSystem } from "@latticexyz/std-client";
import { NetworkLayer } from "../../Network";

export function escapePortal(
  context: {
    network: NetworkLayer;
    actions: ActionSystem;
    world: World;
  },
  entity: EntityIndex,
  escapePortalEntity: EntityIndex
) {
  const {
    network: { api: networkApi },
    world,
    actions,
  } = context;

  const actionID = `escape portal ${Date.now()}` as EntityID; // Date.now to have the actions ordered in the component browser

  actions.add({
    id: actionID,
    components: {},
    on: entity,
    requirement: () => true,
    updates: () => [],
    execute: async () => {
      return networkApi.escapePortal(world.entities[entity], world.entities[escapePortalEntity]);
    },
  });
}
